import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";

function MyTracks() {
  const [tracks, setTracks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const { data: { session } } = await supabase.auth.getSession();
      if (!session?.user?.id) {
        setLoading(false);
        return;
      }
      try {
        const { data, error } = await supabase
          .from("tracks")
          .select("*")
          .eq("artist_id", session.user.id)
          .order("created_at", { ascending: false });
        if (error) throw error;
        setTracks(data || []);
      } catch (err) {
        toast.error(err?.message || "Failed to load tracks");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const refresh = async () => {
    setLoading(true);
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session?.user?.id) return;
      const { data, error } = await supabase
        .from("tracks")
        .select("*")
        .eq("artist_id", session.user.id)
        .order("created_at", { ascending: false });
      if (error) throw error;
      setTracks(data || []);
    } catch (err) {
      toast.error(err?.message || "Failed to refresh tracks");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0b0b0b] text-[#e0e0e0] px-4 py-10">
      <div className="max-w-5xl mx-auto space-y-4">
        <Card className="bg-[#121212] border border-[#1f1f1f]">
          <CardHeader className="flex flex-row items-center justify-between">
            <CardTitle>My Tracks</CardTitle>
            <Button onClick={refresh} size="sm" variant="outline">
              Refresh
            </Button>
          </CardHeader>
          <CardContent>
            {loading ? (
              <div className="text-sm text-[#a0a0a0]">Loading tracks...</div>
            ) : tracks.length === 0 ? (
              <div className="text-sm text-[#a0a0a0]">
                No tracks found. Upload your first track to see it here.
              </div>
            ) : (
              <div className="space-y-2">
                {tracks.map((track) => (
                  <div
                    key={track.id}
                    className="flex items-center justify-between px-3 py-2 rounded bg-[#0f0f0f] border border-[#1f1f1f]"
                  >
                    <div>
                      <div className="font-semibold">{track.title}</div>
                      <div className="text-xs text-[#a0a0a0]">
                        Uploaded: {new Date(track.created_at).toLocaleString()}
                      </div>
                    </div>
                    <div className="text-xs text-[#b0b0b0]">
                      {track.is_active ? "Active" : "Inactive"}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

export default MyTracks;